(function($) {
	formHelper.addRule({
		form: '.form-manage-users',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);

jQuery(function initToolsManageUsers($) {
	$('.manage-users-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-users');

		// Date Created Range
		// ------------------
		var $dateCreatedFrom = $('#date-created-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedFromPicker = $dateCreatedFrom.pickadate('picker');

		var $dateCreatedTo = $('#date-created-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedToPicker = $dateCreatedTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( dateCreatedFromPicker.get('value') ) {
			dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
		}
		
		if ( dateCreatedToPicker.get('value') ) {
			dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
		}

		// When something is selected, update the "dateCreatedFrom" and "dateCreatedTo" limits.
		dateCreatedFromPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedToPicker.set('min', false);
			}
		});

		dateCreatedToPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedFromPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManageUsersResults($) {
	$('.manage-users-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-users-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initEditUser($) {
	$('.edit-user-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-user');
		var $submitBtn             = $container.find('.btn-submit');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-user').val('no');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-user').val('yes');
				$form.submit();
			}			
		});
	});
});

jQuery(function($){
	$('.js-user-actions').change(function() { 
		if($(this).val() !== '') {
			document.location.href = $(this).val(); 
		}
	})
});
